export enum ChargingMethod {
  NO_CHARGE = 1,
  CASH_ON_DELIVERY = 2,
  SELF_PICKUP = 3,
  CHARTER = 4,
  HCT_CHARTER = 5,
  T_CAT = 6,
}

export enum EditFormActionType {
  UPDATE = "update",
  NEW = "new",
  COPY = "copy",
}
// update: 修改, new: 新增, copy: 複製(從new區分出來)
